import { atomEffect } from 'jotai-effect';
import type { Atom } from 'jotai';
import { SocketConnectionWorker } from '../../../components/SocketConnection/CreateWorker';
import { EVENT_GDPR_SETTINGS } from '../../../components/SocketConnection/constants';
import { getGdprMapSettings } from '../../../components/SocketConnection/SocketConnectionService';
import { getDriverId, getUserId } from '../../../Services/UserService';

const isPromise = <T>(value: unknown): value is Promise<T> =>
  typeof value === 'object' && value !== null && 'then' in value;

function sendToSocket(newValue: any[]) {
  const userId = getUserId();
  const driverId = getDriverId();
  const data = {
    event: EVENT_GDPR_SETTINGS,
    payload: getGdprMapSettings(newValue, userId, driverId),
    userId,
  };
  SocketConnectionWorker.postMessage(data);
}

/**
 * Creates an effect atom that sends GDPR settings to socket server when changed
 * Usage:
 *   const gdprSettingsAtom = atom<Record<string, any>>({});
 *   const effectAtom = setGdprSettingsToSocketServerEffect(gdprSettingsAtom);
 *
 *   // Mount the effect in a component:
 *   useAtom(effectAtom);
 */
export const setGdprSettingsToSocketServerEffect = (sourceAtom: Atom<any[] | Promise<any[]>>) =>
  atomEffect((get) => {
    const newValue = get(sourceAtom);

    if (isPromise<any[]>(newValue)) {
      newValue.then((resolvedValue) => sendToSocket(resolvedValue));
    } else {
      sendToSocket(newValue);
    }
  });
